module.exports = __webpack_public_path__ + "media/images/emblems/Ossingen-blazon-113a26c6ceaee5da969e5fbf8decc6c6.svg";